import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MANAGEMENT_ROUTES } from './management.route';
import { QueuingSystemSharedModule } from '../../shared/';
import { ManagementNavigationMenuModule } from './management-navigation-menu';
import { GenericModule, NavigationMenuModule } from '../generic';

import { ManagementComponent } from './management.component';
import { ServiceProviderModule } from '../../services';

import {
    QueueCreateComponent,
    QueueDeleteComponent,
    QueueDeletePopupComponent,
    QueueDetailsComponent,
    QueueEditComponent,
    QueuesComponent
} from './queues';

import { QueuesTreeViewComponent, QueuesTreeViewItemComponent } from './queues/tree-view';

import {
    FacultiesComponent,
    FacultyCreateComponent,
    FacultyDeleteComponent,
    FacultyDeletePopupComponent,
    FacultyDetailsComponent,
    FacultyEditComponent
} from './faculties';

import { UserCreateComponent, UserDetailsComponent, UserResolvePagingParams, UsersComponent } from './users';
import { UserDeleteComponent, UserDeletePopupComponent } from './users/user-delete.component';
import { UserEditComponent } from './users/user-edit.component';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        RouterModule.forRoot(MANAGEMENT_ROUTES),
        ServiceProviderModule,
        NavigationMenuModule,
        ManagementNavigationMenuModule,
        GenericModule
    ],
    declarations: [
        FacultiesComponent,
        FacultyCreateComponent,
        FacultyDetailsComponent,
        FacultyEditComponent,
        FacultyDeleteComponent,
        FacultyDeletePopupComponent,

        QueuesComponent,
        QueueCreateComponent,
        QueueDetailsComponent,
        QueueEditComponent,
        QueuesTreeViewComponent,
        QueuesTreeViewItemComponent,
        QueueDeleteComponent,
        QueueDeletePopupComponent,

        UsersComponent,
        UserDetailsComponent,
        UserCreateComponent,
        UserDeleteComponent,
        UserDeletePopupComponent,

        ManagementComponent,

        UserEditComponent
    ],
    entryComponents: [
        FacultyDeleteComponent,
        QueueDeleteComponent
    ],
    providers: [
        UserResolvePagingParams
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class ManagementModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management.module.ts